import { ReactNode } from 'react';

interface CoverageContentWrapperProps {
  children: ReactNode;
  className?: string;
}

export const CoverageContentWrapper = ({
  children,
  className = '',
}: CoverageContentWrapperProps) => {
  return <div className={className}>{children}</div>;
};
